// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"d9dd4357","66":"e06899e1","787":"f9e631f3"}[chunkId] + ".chunk.js";
};